import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { SingleSelect, } from 'react-select-material-ui';
import { theme } from '../../themes/theme';
import { ErrorLabel } from '../../components/ErrorLabel/ErrorLabel';
import Tooltip from '../../components/Tooltip';
// TODO - storybook (include all cases with props)
const Select = (props) => {
    var _a, _b;
    const required = props.isRequired ? '*' : '';
    const requiredLabel = 'This field is required';
    const isErrorTooltipMessage = props.error && props.errorTooltip;
    const [active, setActive] = useState(false);
    const customStyles = {
        singleValue: (provided) => (Object.assign(Object.assign({}, provided), { marginLeft: 0, border: 0 })),
        menu: (provided) => (Object.assign(Object.assign({}, provided), { width: 'auto', minWidth: '100%' })),
        control: (_, state) => ({
            borderBottom: state.isDisabled
                ? `1px solid ${theme.palette.grey[400]}`
                : `1px solid ${theme.palette.grey[600]}`,
        }),
        menuPortal: (base) => (Object.assign(Object.assign({}, base), { zIndex: 9999 })),
        clearIndicator: (provided) => (Object.assign(Object.assign({}, provided), { color: theme.palette.grey[400], '&:hover': {
                color: theme.palette.grey[600],
            } })),
    };
    const getErrorMessage = () => {
        if (isErrorTooltipMessage && !!props.errorTooltipMessage) {
            return props.errorTooltipMessage;
        }
        else if (isErrorTooltipMessage && props.isRequired) {
            return requiredLabel;
        }
        return '';
    };
    const getLabelColor = () => {
        if (props.disabled) {
            return theme.palette.grey[400];
        }
        else if (active) {
            return theme.palette.primary.main;
        }
        return theme.palette.text.secondary;
    };
    return (_jsx("div", { children: _jsx(Tooltip, Object.assign({ title: getErrorMessage() || '' }, { children: _jsxs("div", { children: [_jsx(Controller, { rules: {
                            required: props.isRequired ? 'This field is required' : undefined,
                            validate: props.validate,
                        }, control: props.control, name: props.name, defaultValue: (_a = props.defaultValue) !== null && _a !== void 0 ? _a : null, render: ({ name, value, onChange, onBlur }) => {
                            var _a, _b, _c, _d, _e;
                            return (_jsx(SingleSelect, { InputLabelProps: {
                                    style: {
                                        color: getLabelColor(),
                                    },
                                }, style: {
                                    textTransform: 'capitalize',
                                    color: props.disabled ? getLabelColor() : '',
                                }, onInput: props.onInput, size: "small", margin: (_a = props.marginType) !== null && _a !== void 0 ? _a : 'dense', label: props.label ? `${props.label}${required}` : '', name: name, onChange: (value, option) => {
                                    onChange(value);
                                    onBlur();
                                    if (props.onChange) {
                                        props.onChange(value, option);
                                    }
                                }, onBlur: (_) => {
                                    onBlur();
                                    if (props.onBlur) {
                                        props.onBlur();
                                    }
                                }, options: (_b = props.options) !== null && _b !== void 0 ? _b : [], value: value, onFocus: props.onFocus, disabled: props.disabled, onFocusCapture: () => setActive(true), onBlurCapture: () => setActive(false), helperText: props.helperText, SelectProps: {
                                    //filter only by visible label for user (prevent filtering by value)
                                    formatOptionLabel: props.formatOptionLabel,
                                    filterOption: (_c = props.filterOption) !== null && _c !== void 0 ? _c : ((option, rawInput) => {
                                        var _a;
                                        return (_a = option.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(rawInput.toLowerCase());
                                    }),
                                    onKeyDown: (event) => {
                                        //stopPropagation fixes handling ot ESC in select inside modal
                                        //ESC should close select dropdown menu and not the whole modal
                                        event.stopPropagation();
                                        if (props.onKeyDown) {
                                            props.onKeyDown(event);
                                        }
                                    },
                                    name: props.name,
                                    msgNoOptionsAvailable: props.noOptionsMessage,
                                    isValidNewOption: (inputValue) => inputValue !== '',
                                    isCreatable: props.isCreatable,
                                    isClearable: props.isClearable,
                                    isSearchable: props.isSearchable,
                                    isLoading: props.isLoading,
                                    menuPlacement: (_d = props.menuPlacement) !== null && _d !== void 0 ? _d : 'auto',
                                    menuShouldBlockScroll: true,
                                    maxMenuHeight: (_e = props.maxMenuHeight) !== null && _e !== void 0 ? _e : 220,
                                    autoFocus: props.autoFocus,
                                    styles: Object.assign(Object.assign(Object.assign({}, customStyles), props.styles), { menu: (provided) => (Object.assign(Object.assign(Object.assign({}, provided), (props.customMenuMargin && {
                                            marginLeft: props.customMenuMargin,
                                            width: 'auto',
                                        })), { zIndex: 11 })), container: () => (Object.assign({}, (props.tableRow && {
                                            margin: 0,
                                            marginTop: '-24px',
                                        }))), valueContainer: () => (Object.assign(Object.assign(Object.assign({ '& > .MuiFormLabel-root': {
                                                maxWidth: 'calc(100% - 8px)',
                                                marginLeft: '2px',
                                                marginRight: '2px',
                                                overflow: 'hidden',
                                                position: 'absolute',
                                                textOverflow: 'ellipsis',
                                                top: '65%',
                                                transform: 'translateY(-50%)',
                                            }, marginRight: '25px' }, (props.tableRow && {
                                            marginRight: '4px',
                                            marginBottom: '4px',
                                        })), (props.textRightAligned && {
                                            justifyContent: 'flex-end',
                                        })), { paddingTop: '12px', '& > div > div > b': {
                                                fontWeight: 'normal',
                                            } })), placeholder: () => (Object.assign(Object.assign({}, (isErrorTooltipMessage && { color: 'red' })), (props.tableRow && {
                                            marginBottom: '-12px',
                                        }))), value: () => (Object.assign({}, (props.textRightAligned && {
                                            textAlign: 'right',
                                        }))), singleValue: (provided) => (Object.assign(Object.assign(Object.assign({}, provided), (props.error &&
                                            props.textRightAligned && {
                                            color: `${theme.palette.error.main}`,
                                        })), { top: '65%' })), option: (provided) => (Object.assign(Object.assign(Object.assign({}, provided), (props.textRightAligned && {
                                            textAlign: 'right',
                                        })), (props.customOptionWidth && {
                                            width: props.customOptionWidth,
                                        }))) }),
                                    menuPortalTarget: document.body,
                                } }));
                        } }), props.error && !props.errorTooltip && (_jsx(ErrorLabel, { children: (_b = props.customError) !== null && _b !== void 0 ? _b : requiredLabel }))] }) })) }));
};
export default Select;
